import Component from '@galactic-advisors/component-loader';

const DEFAULTS = {
  inputFieldElement: '[data-file-upload-field]',
  fileFieldElement: '[data-file-input]',
  submitButtonElement: '[data-submit-button]',
};

export default class FileUpload extends Component {
  static selector = '[data-comp-file-upload]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.fields = [
      ...this.$container.querySelectorAll(this.$options.inputFieldElement),
    ];

    this.fileField = this.$container.querySelector(
      this.$options.fileFieldElement
    );

    this.submitButton = this.$container.querySelector(
      this.$options.submitButtonElement
    );

    this.init();
  }

  init() {
    this.fileField.addEventListener('change', (event) => {
      if (event.target.files.length === 0) {
        alert('Please select a file before submitting.');
      }
      this.submitButton.disabled = false;
    });
  }
}
